import { render } from "./stories_table.vue?vue&type=template&id=9009214a&scoped=true&lang=pug"
import script from "./stories_table.vue?vue&type=script&lang=js"
export * from "./stories_table.vue?vue&type=script&lang=js"

import "./stories_table.vue?vue&type=style&index=0&id=9009214a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9009214a"]])

export default __exports__